import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Grid from '../../common/components/Grid'
import Button from 'material-ui/Button'
import {FormControl} from 'material-ui/Form'
import Input, {InputLabel} from 'material-ui/Input'
import {CircularProgress} from 'material-ui/Progress'
import Dialog, {DialogTitle} from 'material-ui/Dialog'

const styles = theme => ({
  textField: {
    width: '100%',
    marginTop: theme.spacing.unit / 2,
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  buttonWrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

class StepPhone extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  render() {
    const {classes} = this.props

    return (
      <div>
        <Typography>Ingresá tu número de teléfono.</Typography>
        <FormControl fullWidth className={classes.textField}>
          <InputLabel htmlFor="phone">Número de teléfono</InputLabel>
          <Input
            id="phone"
            startAdornment="+54&nbsp;"
            type="tel"
          />
        </FormControl>
        <div className={classes.actionsContainer}>
          <Grid container justify="space-between">
            <Grid item>
              <Button
                disabled={false}
                onClick={this.props.handleBackButtonClick}
                className={classes.button}
              >
                Atrás
              </Button>
            </Grid>
            <Grid item>
              <div className={classes.buttonWrapper}>
                <Button
                  variant="raised"
                  color="primary"
                  disabled={this.props.loading}
                  onClick={this.props.handleNextButtonClick}
                >
                  Siguiente
                </Button>
                {this.props.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
              </div>
            </Grid>
          </Grid>
        </div>
        <Dialog onClose={this.props.closeDialog} open={this.props.dialogIsOpen}>
          <DialogTitle id="simple-dialog-title">Set backup account</DialogTitle>
          <div>
            <Button variant="raised" color="primary" onClick={this.props.closeDialog}>
              Cerrar
            </Button>
            <div className={classes.buttonWrapper}>
              <Button variant="raised" color="primary" onClick={this.props.handleCheckButtonClick}>
                Check
              </Button>
              {this.props.isChecking && <CircularProgress size={24} className={classes.buttonProgress}/>}
            </div>
          </div>
        </Dialog>
      </div>
    )
  }

}

StepPhone.propTypes = {
  handleNextButtonClick: PropTypes.func.isRequired,
  handleBackButtonClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dialogIsOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  handleCheckButtonClick: PropTypes.func.isRequired,
  isChecking: PropTypes.bool.isRequired,
}

export default withStyles(styles, {withTheme: true})(StepPhone)



// WEBPACK FOOTER //
// ./src/sections/firstlogin/StepPhone.js